const API_URL =
  "https://script.google.com/macros/s/AKfycbzbq6kV2V_MWRg11zCMFjQrcRAgGO8w6DWhqpppXJeF4vRypZOHfvCI1BK8GE1GZf0TYg/exec";

export async function loadContactNumbers() {

  try {

    const response = await fetch(API_URL);

    const data = await response.json();

    // ✅ SAVE TO LOCAL STORAGE
    localStorage.setItem("whatsappNumber", "91" + data.whatsapp);

    localStorage.setItem("callNumber", data.call);

    // ✅ GOOGLE SHEET NUMBER UPDATE HOTE HI FLOATING BUTTON KO SIGNAL
    window.dispatchEvent(new Event("contactNumbersUpdated"));

    console.log("Contact numbers loaded");

  } catch (error) {

    console.error("Failed to load contact numbers", error);

  }

}